import { render, staticRenderFns } from "./TaskBody.vue?vue&type=template&id=3370e04d&"
import script from "./TaskBody.vue?vue&type=script&lang=js&"
export * from "./TaskBody.vue?vue&type=script&lang=js&"
import style0 from "./TaskBody.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports